import { render, staticRenderFns } from "./editPermissions.vue?vue&type=template&id=031d61ee&scoped=true&"
import script from "./editPermissions.vue?vue&type=script&lang=js&"
export * from "./editPermissions.vue?vue&type=script&lang=js&"
import style0 from "./editPermissions.vue?vue&type=style&index=0&id=031d61ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031d61ee",
  null
  
)

export default component.exports